import { createTheme } from "@material-ui/core/styles";

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    black?: {
      highEmphasis: string;
      mediumEmphasis: string;
      lowEmphasis: string;
      disabled: string;
      inactive: string;
    };
    uploader?: {
      background: string;
    }
  }
  interface PaletteOptions {
    black?: {
      highEmphasis: string;
      mediumEmphasis: string;
      lowEmphasis: string;
      disabled: string;
      inactive: string;
    };
    uploader?: {
      background: string;
    }
  }
}
  
const theme = createTheme({
  palette: {
      primary: {
        main: "#0E5AE1",
        900: "#00328C",
        800: "#0242B4",
        700: "#064CC9",
        600: "#0552DC",
        500: "#0E5AE1",
        400: "#3377EF",
        300: "#567FBD",
        200: "#90C0F9",
        100: "#BBD8FB",
        50: "#E3EFFD",
      },
      error: {
        main: "#DD3100",
        dark: "#B91919",
        light: "#FFF6F4",
      },
      warning: {
        main: "#FDBE00",
        dark: "#B91919",
        light: "#FFF5E5",
      },
      success: {
        main: "#3EC528",
        dark: "#18AB00",
        light: "#F7FCF9",
      },
      black: {
        highEmphasis: "#505565",
        mediumEmphasis: "rgba(0, 0, 0, 0.7)",
        lowEmphasis: "#808285",
        disabled: "#9E9E9E",
        inactive: "rgba(0, 0, 0, 0.54)",
      },
      uploader: {
        background: "#F7F9FC",
      }
    },
  });

  export default theme;